<template>
	<div>
		<div class="row">
			<div class="mb-3">          
				<el-collapse>
					<el-collapse-item>
						<template slot="title">
							<span style="color:#606266;font-size:14px;"><i class="header-icon el-icon-search"></i>&nbsp;&nbsp;&nbsp;Filter</span>
						</template>
						<el-form label-position="top" label-width="100px">

							<div class="row">
								<div class="col-md-6">
									<!--<ReportParamDateRange title="Date" v-model="date" />-->
									<el-form-item label="Date Range:">
										<div class="block">
											<el-date-picker
											v-model="dateRange"
											type="daterange"
											align="right"
											size="small" 
											unlink-panels
											range-separator="-"
											start-placeholder="Start date"
											end-placeholder="End date"
											format="yyyy-MM-dd"
											value-format="yyyy-MM-dd"
											:picker-options="pickerOptions">
											</el-date-picker>
										</div>
									</el-form-item>
								</div>

								<div class="col-md-6">
									<el-form-item label="Status">
										<el-radio-group v-model="status" size="small" name="status">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.status" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>

								<div class="col-md-6">
									<el-form-item label="Rekap">
										<el-radio-group v-model="rekap" size="small" name="rekap">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.rekap" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>

							</div>
								
							<div class="row mt-2">
								<div class="col-md-6">
									<el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply Filter</el-button>
								</div>
							</div>
						</el-form>
					</el-collapse-item>
				</el-collapse>
			</div>

			<div class="row" v-show="false">
				<div class="col-md-3 mb-3">
					<el-checkbox v-model="showchart">Show Chart</el-checkbox>
				</div>
				<div class="col-md-4 mb-3" v-if="showchart">
					<el-radio-group v-model="charttype">
						<el-radio label="barchart" size="small">Bar Chart</el-radio>
						<el-radio label="linechart" size="small">Line Chart</el-radio>
					</el-radio-group>
				</div>

				<div class="col-md-3" v-if="showchart && charttype=='barchart' ">
					<el-checkbox v-model="stacked">Stacked</el-checkbox>
				</div>
				
			</div>
			<div class="mb-0" >
				<BarChart v-loading.body="loading.table" :data="chartdata" :width="500" :height="380" v-if="showchart && charttype=='barchart'" />
				<LineChart v-loading.body="loading.table" :data="chartdata" :width="500" :height="192" v-if="showchart && charttype=='linechart'" style="margin-top:20px;"/>
			</div>

			<div class="mt-0">
				<ReportResultTable :reportname="'CustomerComplaint'" :reportdata="reportdata" :loading="loading.table" :reporturl="urlRequestParams" :issuccess="loading.isSuccess" style="width:100%;"/> 
			</div>
		</div>
	</div>
</template>

<script>

import Customer from '@/components/page/Customer.js'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import { Rainbow, Rainbow2, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'

export default
{
	extends: Customer,
	props: ['tabIndex','tabName', 'tabLabel'],
	components: { 
		//ReportParamSelect,
		ReportResultTable,
		LineChart,
		BarChart,
		//Loader,
	},

	data(){
		return {
			date: { 
				Start: this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().mingguSekarang,
				End: this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin, 
			},
			charttype: 'linechart', //barchart //linechart
			urlRequestParams: '',
			dateRange: [this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().mingguSekarang,this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin], 
			
			options: {
				status:[
					{ value: "", name: "ALL" }, 
					{ value: "On Progress", name: "ON PROGRESS" }, 
					{ value: "Close", name: "CLOSE" },
				],
				rekap:[
					{ value: "", name: "ALL" }, 
					{ value: "status", name: "BY STATUS" }, 
				],
			},

			reportdata: [],
			chartdata: [],
			showchart: false,
			stacked: true,
			status : this.$route.query.status ? this.$route.query.status : '',
			rekap : this.$route.query.rekap ? this.$route.query.rekap : '',
			
			loading: {
				table: false,
				chart: false,
				isSuccess: false,
			},

			pickerOptions: {
				shortcuts: [{
					text: 'Last week',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last month',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last 3 months',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
					picker.$emit('pick', [start, end]);
					}
				}]
			},

		}
	},
	watch:
	{
		reportdata() { this.refreshChart(); },
		stacked() { this.refreshChart(); },

	}, 
    mounted()
    {
		Array.from(document.querySelectorAll('aside li.nav-item a')).map((e)=>{e.classList.remove('active')})
        document.querySelector('li.nav-item a.'+window.location.pathname.split('/')[1]).classList.add('active')
		
        this.$emit('childrenRoute');
		this.resumePilihan()
		
    },
    methods:{
		floatingSearchForm(){
			document.querySelector('.search.form').classList.toggle('floating')            
		},
		searchFilterButtonClick(){
			document.querySelector('li.filter').classList.toggle('down')
			var select=document.querySelectorAll('.search.form')
			Array.from(select).map((e)=>{e.classList.toggle('minimize')})
		},

		refreshChart() {
			let a = this.detail2 == "item" ? "ItemName" : "StatusPSO"
			let b = "Period"
			let c = Rainbow
			
			if (!this.period) {
				b = "Channel"
			}
			if (this.channel == "channel") {
				a = "Channel"
				c = Rainbow2
			}
			else if (this.tabIndex == 0 && this.source == "source") {
				a = "Source"
				c = Rainbow2
			}
			if (this.detail1 == "area") {
				a = "SalesArea"
			}
			else if (this.detail1 == "province") {
				a = "ProvinceName"
			}
			this.chartdata = this.processBarChart(this.reportdata.data, a, "", "TotalSalesExTax", false, b, "", 1000000, 2, c, false, false, false, this.stacked);
		},

		resumePilihan() {
            this.urlRequestParams=Config().apiURL
			if (this.tabIndex == 0) this.urlRequestParams+='/customer/complaint135?'
			else if (this.tabIndex == 1) this.urlRequestParams+='/customer/complaintspbu?'
            
			//this.urlRequestParams+='&date-range-start='+this.date.Start
            //this.urlRequestParams+='&date-range-end='+this.date.End
			this.urlRequestParams+='&date-range-start='+ this.dateRange[0]
			this.urlRequestParams+='&date-range-end='+ this.dateRange[1]

            this.urlRequestParams+='&status='+this.status
            this.urlRequestParams+='&rekap='+this.rekap

			this.loading.table = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                this.reportdata = response.data;

            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.table = false;
			})

            

        },
		
		applyFilter() {
			this.resumePilihan()
        },
		
		
    }
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>